<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="2000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Get Password</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row dense justify-center>
                    <v-col cols="12" sm="6" md="6">
                        <v-combobox color="#0F2027" v-model="username" @change="setnull()" rounded :items="all_users"
                            label="Select Username" item-text="username" outlined
                            prepend-icon="mdi-account-child-circle"></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" v-if="username">
                        <v-btn class="button" :disabled="isallowed == false ? true : false" @click="getPassword()">
                            Get Password
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row justify="center" v-if="user_password && username.username">
                    <span style="font-size : 18px;"> Password of {{username.username}} is : <b>{{user_password}}</b>
                    </span><v-icon class="icon-quick " title="Copy the password" @click="copy">mdi-content-copy</v-icon>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css";
import sha256 from 'js-sha256'
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            isallowed: false,
            // extraBreadcrumbItems: [


            // ],
            breadcrumbClass: "breadcrumb-style1",
            username: null,
            user_password:null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            all_users:[]
        }),

        methods: {
            setnull(){
                this.user_password=null
               // this.username=null
            },
            copy(){
                navigator.clipboard.writeText(this.user_password);
                alert("Password copied to clipboard!!!")
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            getPassword(){
                if  (this.username.username=='' ||this.username.username==null){
                     this.showSnackbar("red", "Please Select Username...");
                     return
                }
                let checksum=sha256(this.username.username+process.env.VUE_APP_SHA_KEY)
                const formData={
                    checksum:checksum,
                    username:this.username.username,
                }
                this.user_password = null
                axios
                .post("/Admin/getUsernamePassword",formData)
                .then((res) => {
                    if(res.data.flag=="YES"){
                        this.user_password = res.data.user_password
                        this.isallowed=res.data.isallowed
                    }
                     else if(res.data.flag=="No"){
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.onerror(error);
                   
                });
            }
        },
        mounted() {
          axios
            .post("/Admin/getAllUser")
            .then((res) => {
                if (res.data.flag == "No") {
                this.showSnackbar("red",res.data.snackbar)
                 this.load = false;
                }else{
                this.all_users = res.data.all_users
                this.isallowed = res.data.isallowed;
                this.load = true;
                  }
              })
            .catch((error) => {
              window.console.log(error);
            });
        },
    };
</script>

<style></style>
